<template>
	<div class="wrapper">
		<div id="map"></div>
		<svg
			version="1.1"
			class="marker"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			width="25.1px"
			height="40.228px"
			viewBox="403.95 503.062 25.1 40.228"
			enable-background="new 403.95 503.062 25.1 40.228"
			xml:space="preserve"
		>
			<text style="font: italic 20px serif; fill: #000">Pilne!</text>
			<rect x="410.279" y="507.574" fill="#FFFFFF" width="12.625" height="14.5" />
			<linearGradient
				id="SVGID_1_"
				gradientUnits="userSpaceOnUse"
				x1="436.9465"
				y1="487.176"
				x2="436.9465"
				y2="524.7421"
				gradientTransform="matrix(1 0 0 -1 -20.4463 1028.1743)"
			>
				<stop offset="0" style="stop-color: #126fc6" />
				<stop offset="1" style="stop-color: #4c9cd1" />
			</linearGradient>
			<linearGradient
				id="SVGID_2_"
				gradientUnits="userSpaceOnUse"
				x1="345.3665"
				y1="505.6882"
				x2="345.3665"
				y2="524.7412"
				gradientTransform="matrix(1 0 0 -1 71.1338 1028.1743)"
			>
				<stop offset="0" style="stop-color: #2e6c97" />
				<stop offset="1" style="stop-color: #3883b7" />
			</linearGradient>
			<path
				fill="url(#SVGID_1_)"
				stroke="url(#SVGID_2_)"
				stroke-width="1.1"
				stroke-linecap="round"
				d="M416.544,503.612
        c-6.573,0-12.044,5.691-12.044,11.866c0,2.778,1.563,6.308,2.693,8.746l9.307,17.872l9.262-17.872
        c1.13-2.438,2.738-5.791,2.738-8.746C428.5,509.303,423.116,503.612,416.544,503.612L416.544,503.612z M416.544,510.767
        c2.584,0.017,4.679,2.122,4.679,4.71s-2.095,4.663-4.679,4.679c-2.584-0.017-4.68-2.09-4.68-4.679
        C411.865,512.889,413.96,510.783,416.544,510.767z"
			/>
			<path
				fill="none"
				stroke="#FFFFFF"
				stroke-width="1.1"
				stroke-linecap="round"
				stroke-opacity="0.122"
				d="M416.531,504.719
        c-5.943,0-10.938,5.219-10.938,10.75c0,2.358,1.442,5.832,2.563,8.25l0.031,0.03l8.313,15.97l8.25-15.97l0.03-0.03
        c1.136-2.448,2.625-5.706,2.625-8.25C427.406,509.931,422.475,504.719,416.531,504.719z M416.531,509.688
        c3.168,0.021,5.781,2.601,5.781,5.781c0,3.18-2.613,5.761-5.781,5.78c-3.168-0.02-5.75-2.609-5.75-5.78
        C410.781,512.297,413.363,509.708,416.531,509.688z"
			/>
		</svg>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import L from 'leaflet'
import moment from 'moment'
import 'leaflet.markercluster'
import 'leaflet-routing-machine'

import bus from '@/EventBus'
import config from '@/config'
import { normalizeApiMontageDate, normalizeApiMontageTime } from '@/helpers'

export default {
	name: 'Map',
	data() {
		return {
			map: null,
			markers: new L.MarkerClusterGroup({ showCoverageOnHover: false, maxClusterRadius: 20 })
			// markersList: []
		}
	},
	computed: {
		...mapState('orders', ['currentOrder']),
		...mapGetters('auth', ['isAdmin', 'user'])
	},
	methods: {
		populateMarkers() {
			const OrderMarker = L.Marker.extend({
				options: {
					order: {
						status: 'new'
					}
				}
			})

			const baseMarkerSvg = document.getElementsByClassName('marker')[0]
			const order = {
				status: 'new'
			}
			for (let i = 0; i < 100; i++) {
				order.id = i
				baseMarkerSvg.setAttribute('order-id', order.id)
				baseMarkerSvg.setAttribute('order-status', order.status)
				const icon = new L.divIcon({
					html: baseMarkerSvg.outerHTML
				})
				const marker = new OrderMarker(this.getRandomLatLng(this.map), { icon: icon, order })
				this.markers.addLayer(marker)
			}
		},
		getRandomLatLng(map) {
			const bounds = map.getBounds()
			const southWest = bounds.getSouthWest()
			const northEast = bounds.getNorthEast()
			const lngSpan = northEast.lng - southWest.lng
			const latSpan = northEast.lat - southWest.lat
			return new L.LatLng(
				southWest.lat + latSpan * Math.random(),
				southWest.lng + lngSpan * Math.random()
			)
		},
		initMap() {
			const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				maxZoom: 18,
				attribution:
					'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
			})
			const polandCenter = new L.LatLng(52, 19)
			this.map = new L.map('map', { center: polandCenter, zoom: 7, layers: [tiles] })
		},
		getOrderCreatorId(order) {
			if (!order.creator) return ''
			if (order.creator.id) return order.creator.id
			if (typeof order.creator !== 'string') return ''
			const orderCreatorSplited = order.creator.split('/')
			return Number(orderCreatorSplited[orderCreatorSplited.length - 1])
		},
		canNonAdminSeeRouteAsAdmin() {
			return this.isAdmin || config.company.canNonAdminSeeRouteAsAdmin
		},
		normalizeMontageDate(montageDate) {
			return normalizeApiMontageDate(montageDate)
		},
		normalizeMontageTime(montageTime) {
			return normalizeApiMontageTime(montageTime)
		},
		addMarker(order, markerColor) {
			const OrderMarker = L.Marker.extend({
				options: { order }
			})

			this.baseMarkerSvg.removeAttribute('route-color')
			// if order has isConcept or isGroundPrepared set, set color to yellow, otherwise use route color
			if (!markerColor) {
				if (order.route && order.route.color) {
					markerColor = order.route.color
				} else if (order.isConcept) {
					markerColor = 'żółty'
				} else if (order.isGroundPrepared) {
					markerColor = 'jasny zielony'
				}
			}
			if (markerColor) this.baseMarkerSvg.setAttribute('route-color', markerColor)
			const icon = new L.divIcon({ html: this.baseMarkerSvg.outerHTML })
			const coords = new L.LatLng(order.lat, order.lon)
			const marker = new OrderMarker(coords, { icon, order })
			const normalizedMontageDate = this.normalizeMontageDate(order.montageDate)
			const montageDate = normalizedMontageDate
				? moment(normalizedMontageDate, 'DD-MM-YYYY').format('DD.MM.YYYY')
				: '-'
			const montageTime = this.normalizeMontageTime(order.montageTime)
			const montageDateTime = montageTime && montageDate !== '-' ? `${montageDate} ${montageTime}` : montageDate

			// convert new lines to <br /> tags
			const details = order.details ? order.details.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-'

			const textForNonAdmins = [`<b>#${order.id}</b>`, `(ukryte)`].join('<br />')

			const textForAdmins = [
				`<b>#${order.id} ${order.clientName || '-'}</b>`,
				`<b>Produkt:</b> ${order.productType || '-'}`,
				`<b>Opis produktu:</b> ${details}`,
				`<b>Cena:</b> ${order.price || '-'} ${
					order.price ? this.getCurrencyLabel(order.currency) : ''
				}`,
				`<b>Dodano:</b> ${moment(order.createdDate).format('DD.MM.YYYY HH:mm')}`,
				`<b>Montaż:</b> ${montageDateTime}`
			].join('<br />')

			const text =
				this.canNonAdminSeeRouteAsAdmin() || this.user.id === this.getOrderCreatorId(order)
					? textForAdmins
					: textForNonAdmins

			marker.bindTooltip(text, {
				direction: 'top',
				offset: L.point(0, -40)
			})
			this.markers.addLayer(marker)
		},
		removeMarker(orderId) {
			this.map.eachLayer((layer) => {
				if (layer.options.order.id === orderId) this.map.removeLayer(layer)
			})
		},
		removeAllMarkers() {
			// console.log('remove all markers', this.markers.eachLayer.length)
			this.markers.eachLayer((layer) => {
				if (layer instanceof L.Marker) this.markers.removeLayer(layer)
			})
		},
		getCurrencyLabel(currency) {
			switch (currency) {
				case 'PLN':
					return 'zł'
				case 'CZK':
					return 'Kč'
				default:
					return currency
			}
		}
	},
	mounted() {
		this.initMap()
		this.baseMarkerSvg = document.getElementsByClassName('marker')[0]
		// this.populateMarkers()

		// this.markers.on('clusterclick', a => alert('cluster ' + a.layer.getAllChildMarkers().length))
		this.markers.on('click', (a) => {
			// don't open order dialog if user is not admin and order is not his
			if (
				!this.canNonAdminSeeRouteAsAdmin() &&
				this.user.id !== this.getOrderCreatorId(a.layer.options.order)
			) {
				this.$snackbar.open('Nie masz uprawnień do wyświetlenia tego zamówienia')

				return false
			}

			this.$emit('order-click', a.layer.options.order)
		})
		this.map.addLayer(this.markers)

		// TEST
		// L.Routing.control({
		// 	router: L.Routing.mapbox(
		// 		'pk.eyJ1IjoiYmFydGhpY3VzIiwiYSI6ImNqdzBwbzgzczBjaTA0OW8yN2kxNGpvb3gifQ.gJ7H228r7RQj8A-1_XAGzg'
		// 	),
		// 	waypoints: [L.latLng(50.815, 19.848), L.latLng(51.027, 17.416), L.latLng(49.649, 21.454)]
		// 	// routeWhileDragging: true,
		// 	// geocoder: L.Control.Geocoder.nominatim()
		// })
		// 	.on('routesfound', function(e) {
		// 		var routes = e.routes
		// 		console.log('Found ' + routes.length + ' route(s).', routes)
		// 	})
		// 	// .on('routingstart', showSpinner)
		// 	// .on('routesfound routingerror', hideSpinner)
		// 	.addTo(this.map)
	},
	created() {
		bus.$on('orders-table-row-select', (rows) => {
			this.removeAllMarkers()
			if (rows.length)
				rows.forEach((order) => {
					this.addMarker(order, order.isUrgent ? 'urgent' : undefined)
				})
		})
		bus.$on('order-updated', () => {
			this.removeAllMarkers()
			// this.currentOrder
			// if (rows.length) rows.forEach(order => this.addMarker(order))
		})
		bus.$on('routes-table-row-select', (rows) => {
			this.removeAllMarkers()
			if (rows.length)
				rows.forEach((route) => {
					if (!route.orders.length) return false
					route.orders.forEach((order) => {
						if (order.lat && order.lon) this.addMarker(order, route.color)
					})
				})
		})
		bus.$on(['orders-loaded', 'change-view-mode'], () => {
			this.removeAllMarkers()
		})
	}
}
</script>

<style lang="scss">
@import './../../node_modules/leaflet/dist/leaflet.css';
@import './../../node_modules/leaflet.markercluster/dist/MarkerCluster.css';
@import './../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css';
@import './../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css';
#map,
.wrapper {
	width: 100%;
	height: 100%;
}
.wrapper > .marker {
	display: none;
}
.marker {
	margin-left: -6px;
	margin-top: -28px;
	path {
		fill: #cccccc;
	}
	path:last-child {
		stroke: none;
	}
	&[route-color='czerwony'] {
		path {
			fill: #d92121;
		}
	}
	&[route-color='jasny czerwony'] {
		path {
			fill: #ffcccb;
		}
	}
	&[route-color='ciemny czerwony'] {
		path {
			fill: #8b0000;
		}
	}
	&[route-color='zielony'] {
		path {
			fill: #b0bf1a;
		}
	}
	&[route-color='jasny zielony'] {
		path {
			fill: #90ee90;
		}
	}
	&[route-color='ciemny zielony'] {
		path {
			fill: #008443;
		}
	}
	&[route-color='żółty'] {
		path {
			fill: #fada5e;
		}
	}
	&[route-color='jasny żółty'] {
		path {
			fill: #ffff9f;
		}
	}
	&[route-color='ciemny żółty'] {
		path {
			fill: #eedc82;
		}
	}
	&[route-color='niebieski'] {
		path {
			fill: #1974d2;
		}
	}
	&[route-color='jasny niebieski'] {
		path {
			fill: #7cb9e8;
		}
	}
	&[route-color='ciemny niebieski'] {
		path {
			fill: #0048ba;
		}
	}
	&[route-color='różowy'] {
		path {
			fill: #f64a8a;
		}
	}
	&[route-color='jasny różowy'] {
		path {
			fill: #ffb6c1;
		}
	}
	&[route-color='ciemny różowy'] {
		path {
			fill: #e75480;
		}
	}
	&[route-color='pomarańczowy'] {
		path {
			fill: #ffbf00;
		}
	}
	&[route-color='jasny pomarańczowy'] {
		path {
			fill: #fed8b1;
		}
	}
	&[route-color='ciemny pomarańczowy'] {
		path {
			fill: #ff8c00;
		}
	}
	&[route-color='urgent'] {
		transform: scale(1);
		animation: pulse 1s infinite;
		path {
			fill: #ff3860;
		}
	}
}
.leaflet-div-icon {
	background: none;
	border: none;
}
.leaflet-tooltip {
	width: 300px;
	white-space: pre-wrap;
}
@keyframes pulse {
	0% {
		transform: scale(0.85);
	}

	70% {
		transform: scale(1);
	}

	100% {
		transform: scale(0.85);
	}
}
</style>
